const legacyColors = {
    purple: {
        50: '#F6EBFF',
        100: '#E2C1FF',
        200: '#D4A3FF',
        300: '#C17AFF',
        400: '#B560FF',
        500: '#A238FF',
        600: '#9333E8',
        700: '#7328B5',
        800: '#591F8C',
        900: '#44186B'
    },
    white: {
        50: '#fff',
        100: '#fff',
        200: '#fff',
        300: '#fff',
        400: '#fff',
        500: '#fff',
        600: '#fff',
        700: '#fff',
        800: '#fff',
        900: '#fff'
    },
    black: {
        50: '#000',
        100: '#000',
        200: '#000',
        300: '#000',
        400: '#000',
        500: '#000',
        600: '#000',
        700: '#000',
        800: '#000',
        900: '#000'
    }
};
export default legacyColors;

//# sourceMappingURL=legacy-colors.js.map